import styled from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";

export const Container = styled(ContainerSection)``;

export const AreaHeader = styled.div``;
export const SubHeader = styled.h5`
	color: ${({ theme }) => theme.red};
	font-size: 0.8rem;
	font-weight: bold;
	margin: 6px 0 0;
`;

export const GridLogistic = styled.div``;
